import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Legend, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabH as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabH = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const yesField = () => {
    const propertyName = pn<AprResponseModel>("yes");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.yes} {formatPercentTotal(props.data?.yes, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const noField = () => {
    const propertyName = pn<AprResponseModel>("no");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.no} {formatPercentTotal(props.data?.no, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknownField = () => {
    const propertyName = pn<AprResponseModel>("unknownDualEnrollment");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknownDualEnrollment} {formatPercentTotal(props.data?.unknownDualEnrollment, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
        {props.totalTabA != props.data?.totalParticipants && (
          <Typography color="error" variant="caption">
            Your Total Participants does not equal Total Participants in section A
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Participants in Dual Enrollment Programs</Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              <Grid item xs={12}>
                {yesField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {noField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {unknownField()}
              </Grid>
              <GridBreak />

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          <Grid item xs={6}>
            <PieChart id="pie-tab-h" dataSource={props.data?.chartValues} palette="Bright" title="Participants" width="100%">
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid>
          
        </Grid>
      </Stack>
    </Card>
  );
};
